window['proposal_lists#index'] = function () {
  // function addItems (idsArr) {
  //   $.ajax({
  //     type: 'POST',
  //     url: 'proposal_lists/add_all_to_list',
  //     data: { ids: idsArr }
  //   })
  // }

  // function deleteItems (idsArr) {
  //   $.ajax({
  //     type: 'POST',
  //     url: 'proposal_lists/remove_all_from_list',
  //     data: { ids: idsArr }
  //   })
  // }

  $('input.proposal-list-checkbox').on('click', function (e) {
    const value = e.target.value
    const checked = e.target.checked
    if (checked) {
      $.ajax({
        type: 'DELETE',
        url: 'proposal_lists/remove_proposal_from_list',
        data: { id: value },
        success: showSaveMessage($(e.target).parents('tr'))
      })
    } else {
      $.ajax({
        type: 'POST',
        url: 'proposal_lists/add_proposal_to_list',
        data: { id: value },
        success: showSaveMessage($(e.target).parents('tr'))
      })
    }
  })

  function showSaveMessage (tr) {
    $('.save-message', tr).fadeIn(function () {
      setTimeout(() => $('.save-message', tr).fadeOut(), 1000)
    })
  }
}
